import Header from './components/Header';
import Hero from './components/Hero';
import SearchBar from './components/SearchBar';
import Stats from './components/Stats';
import About from './components/About';
import Services from './components/Services';
import Listings from './components/Listings';
import Process from './components/Process';
import Areas from './components/Areas';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Team from './components/Team';
import CTABanner from './components/CTABanner';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import './App.css';

function App() {
  return (
    <div className="site-shell">
      <Header />
      <main>
        <Hero />
        <SearchBar />
        <Stats />
        <About />
        <Services />
        <Listings />
        <Process />
        <Areas />
        <Gallery />
        <Testimonials />
        <Team />
        <CTABanner />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
export default App;
